import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import coin from "../assets/images/coin.png";
import "./Gifts.css";
import { HttpService } from "../service/HttpService";
import Constant from "../constant/Constant";
import Header from "../Common/Header/Header";
import AlertComponent from "../Common/Alert/Alert";
import TemporaryDrawer from "../Common/Header/mobile_header";
import StarIcon from "@material-ui/icons/Star";
import CloseIcon from "@material-ui/icons/Close";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
var QRCode = require("qrcode.react");

const Gifts = (props) => {
  const httpService = new HttpService();

  const [voucher, setVoucher] = useState([]);
  const [value, setValue] = useState({ id: "", userId: "" });
  const [alert, setAlert] = useState(false);
  const [redeemOption, setRedeemOption] = useState({});

  var id = "";
  if (
    props === undefined ||
    props.location === undefined ||
    props.location.state === undefined ||
    props.location.state.id === undefined
  ) {
    props.history.push("/company");
  } else {
    id = props.location.state.id;
  }
  const gifts = () => {
    console.log();
    httpService
      .getApi(
        "redeemVoucherMaster/by/vendor?vendorId=" +
          id +
          "&sort=createdDate,desc"
      )
      .then(
        (response) => {
          setVoucher(response.data.content);
          console.log(response);
        },
        (error) => {
          console.log(error);
        }
      );
  };

  useEffect(() => {
    gifts();
  }, []);

  const { buttonLabel, className } = props;

  const [modal, setModal] = useState(false);
  const [visible, setVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const toggle = (reward) => {
    if (localStorage.getItem("balance") < reward.amount) {
      setErrorMessage("Insufficent balance")
      setAlert(true);
    } else {
      checkUserRedeemLimit(reward);
    }
  };

  const closeModal = () => {
    setModal(false);
  };

  const closeVisible = () => {
    setVisible(false);
  };

  const onDismiss = () => {
    setAlert(false);
  };

  const getUserInfo = (reward) => {
    let obj = {};
    if (
      localStorage.getItem("user") !== undefined &&
      localStorage.getItem("user") !== null
    ) {
      obj = JSON.parse(localStorage.getItem("user"));

      value.id = reward.id;
      value.userId = obj.userId;
      value.points = reward.amount;

      setValue({ ...value });
    }
  };

  const checkUserRedeemLimit = (reward) => {
    httpService
      .getApi(
        "userRedeemHistory/check_redeem_limit?voucherId=" + reward.id
      )
      .then(
        (response) => {
          setRedeemOption(reward);
          getUserInfo(reward);
          setModal(true);
        },
        (error) => {
          const errMessage = error.response.data;
          setErrorMessage(errMessage.message);
          setAlert(true)
        }
      );
  };

  return (
    <>
      <Header />
      <TemporaryDrawer />
      {alert && (
        <AlertComponent
          color="danger"
          message={errorMessage}
          alert={alert}
          onDismiss={onDismiss}
        />
      )}
      <div className="gifts_sec">
        <Container>
          <div className="listings">
            <Row>
              {voucher.map((i) => (
                <Col lg={4} md={6} key={i.id}>
                  <div className="box" onClick={() => toggle(i)}>
                    <img
                      className="img-fluid"
                      src={Constant.IMAGE_BASE_URl + i.imageUrl}
                      alt="coffe-imgg"
                    />
                    <div className="head">
                      <h1>
                        <img src={coin} alt="coin-imgg" />
                        {i.amount} Points
                      </h1>
                      <p style={{ fontSize: "20px", fontWeight: "800px" }}>
                        {i.description}
                      </p>
                    </div>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </Container>
        <Modal isOpen={modal} toggle={closeModal} className={className}>
          {/* <ModalHeader toggle={closeModal}>Show to Vendor</ModalHeader> */}
          <ModalBody style={{ padding: "0px", backgroundColor: "#c94d3d" }}>
            {/* <img src={qrcode} style={{ "width": "300px", "height": "300px" }} alt="qr-imgg" /> */}
            <div
              style={{
                width: "100%",
                height: "400px",
                backgroundColor: "#32e8d8",
                borderBottomRightRadius: "30px",
              }}
            >
              <img
                style={{
                  height: "300px",
                  width: "100%",
                  objectFit: "cover",
                  backgroundColor: "white",
                  borderBottomLeftRadius: "30px",
                  borderBottomRightRadius: "30px",
                }}
                src={Constant.IMAGE_BASE_URl + redeemOption.imageUrl}
                alt="coffe-imgg"
              />
              <CloseIcon
                style={{ position: "absolute", top: "2%", left: "2%" }}
                onClick={closeModal}
              />

              <div
                style={{
                  textAlign: "center",
                  flexDirection: "row",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {" "}
                <StarIcon style={{ color: "white" }} />
                <StarIcon style={{ color: "white" }} />
                <StarIcon style={{ color: "white" }} />
                <StarIcon style={{ color: "white" }} />
                <p style={{ color: "#c94d3d", fontSize: "65px" }}>
                  {redeemOption.amount}
                </p>{" "}
                <p style={{ color: "#c94d3d", fontSize: "20px" }}> pts</p>
              </div>
            </div>
            {/* <QRCode
    id="123456"
    value={JSON.stringify(value)}
    size={290}
    level={"H"}
    includeMargin={true}
  />
  <p style={{textAlign:'center'}}>
   {value.id.substring(3,9)+value.userId.substring(3,9)}  </p>  */}
          </ModalBody>
          <ModalFooter
            style={{
              border: "none",
              backgroundColor: "#c94d3d",
              borderTopLeftRadius: "30px",
              justifyContent: "center",
            }}
          >
            <p style={{ color: "white" }} onClick={() => setVisible(true)}>
              REDEEM
              <ArrowForwardIosIcon fontSize="small" />
              <ArrowForwardIosIcon fontSize="small" />
              <ArrowForwardIosIcon fontSize="small" />
            </p>{" "}
          </ModalFooter>
        </Modal>

        <Modal isOpen={visible} toggle={closeVisible} className={className}>
          <ModalHeader
            style={{ backgroundColor: "white" }}
            toggle={closeVisible}
          >
            Show to Vendor
          </ModalHeader>
          <ModalBody
            style={{
              backgroundColor: "white",
              width: "100%",
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            {/* <img src={qrcode} style={{ "width": "300px", "height": "300px" }} alt="qr-imgg" /> */}

            <QRCode
              id="123456"
              value={JSON.stringify(value)}
              size={290}
              level={"H"}
              includeMargin={true}
            />
            {/* {{value}} */}
            <p style={{ textAlign: "center" }}>
              {value.id[3] +
                value.id.substring(7, 9) +
                value.userId[3] +
                value.userId.substring(7, 9)}{" "}
            </p>
          </ModalBody>
          <ModalFooter style={{ backgroundColor: "white" }}>
            <Button color="primary" onClick={closeVisible}>
              OK
            </Button>{" "}
            <Button color="secondary" onClick={closeVisible}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>

        {/* floating button for qr scanner  */}
        {/* <div className="qr-reader">
                    <Link to="/qrcode">
                        <img src={qranimation} style={{width:'100px',height:'100px'}} alt="qranimation" />
                    </Link>
                </div> */}
        {/* floating button for qr scanner  */}
      </div>
    </>
  );
};
export default Gifts;
